<template>
  <div class="row">
    <div class="col-12" v-if="cotacoes.length > 0">
      <h1 class="title font-weight-bold text-uppercase">
        Cancelamento aguardando análise
      </h1>
      <hr class="linha-amarela" />
      <table class="table">
        <thead>
          <tr>
            <th scope="col">Cot. Id</th>
            <th scope="col">Solicitado</th>
            <th scope="col">Nome/Empresa</th>
            <th scope="col">Fone/Cell</th>
            <th scope="col">Valor Total</th>
            <th scope="col">Taxa canc.</th>
            <th scope="col">Status</th>
            <th scope="col">Ações</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(dados, i) in cotacoes" :key="i">
            <th>{{ dados.cotacao.id }}</th>
            <th>{{ dados.tipo.user }}</th>
            <td>{{ dados.tipo.dados.nome_fantasia ? dados.tipo.dados.nome_fantasia : dados.tipo.dados.nome }}</td>
            <td>{{ dados.tipo.dados.telefone ? dados.tipo.dados.telefone : dados.tipo.dados.celular }}</td>
            <td>{{ dados.valor_total }}</td>
            <td>{{ dados.taxa_cancelamento }}</td>
            <td>{{ dados.status_cancelamento }}</td>
            <td>
              <span class="verCotacao" @click="detalhesCancelamento(dados.cotacao.id)">Detalhes</span>
              <span class="pagarCotacao" v-if="dados.status_cancelamento != 'Finalizado'" @click="cobrarTaxa(dados)">Pagar</span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div v-else>
      <h1 class="title font-weight-bold text-uppercase">
        Sem pedidos de cancelamento
      </h1>
      <hr class="linha-amarela" />
    </div>
    <b-modal
      title="Realizar cobrança de taxa"
      size="md"
      id="pagar"
      header-bg-variant="orange"
      header-text-variant="light"
      centered
      hide-footer
    >
      <div>
        <h4 class="text-center mt-3">Confirma o recebimento de {{ valor }} do usuário {{ user }}</h4>
        <div class="row validPayment">
          <div class="col-6">
            <span class="resSim" @click="sendPayment()">SIM</span>
          </div>
          <div class="col-6">
            <span class="resNao" @click="$bvModal.hide('pagar')">NÃO</span>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
export default {
  data() {
    return {
      cotacoes: {
        length: 0
      },
      valor: null,
      user: '',
      cot_id: null
    }
  },

  created() {
    this.showQuotesCanceled();
  },

  methods: {
    cobrarTaxa(dados) {
      this.cot_id = dados.cotacao.id;
      this.valor = dados.taxa_cancelamento;
      this.user = dados.tipo.dados.nome_fantasia ? dados.tipo.dados.nome_fantasia : dados.tipo.dados.nome;
      this.$bvModal.show('pagar');
    },
    detalhesCancelamento(id) {
      this.$router.push({ name: 'administrador-cotacoes-detalhes', params: { id } });
    },
    sendPayment() {
      this.$store.dispatch('startLoader');
      this.$store.dispatch('sendCanceledPayment', this.cot_id)
      .then(() => {
        this.$bvModal.hide('pagar');
        this.valor = null;
        this.cot_id = null;
        this.user = '';
        this.showQuotesCanceled()
        this.$store.dispatch('endLoader');
        
      })
      .catch((e) => {
        this.$bvModal.hide('pagar');
        this.$store.dispatch('endLoader');
        console.log(e)
      });
    },
    showQuotesCanceled() {
      this.$store.dispatch('startLoader');
      this.$store.dispatch('showQuotesCanceled')
      .then((response) => {
        this.cotacoes = response.data.data;
        this.$store.dispatch('endLoader');
        
      })
      .catch((e) => {
        this.$store.dispatch('endLoader');
        console.log(e)
      });
    }
  }
}
</script>

<style scoped>
.verCotacao {
  background-color: #ee9b00;
  color: #FFF;
  padding: 4px 10px;
  border-radius: 4px;
  cursor: pointer;
  margin-right: 10px;
}
.pagarCotacao {
  background-color: #39c940;
  color: #FFF;
  padding: 4px 10px;
  border-radius: 4px;
  cursor: pointer;
}
.validPayment {
  text-align: center;
  margin-top: 40px;
  margin-bottom: 20px;
}
.resSim {
  background-color: #39c940;
  color: #FFF;
  padding: 7px 15px;
  border-radius: 5px;
  cursor: pointer;
}
.resNao {
  background-color: #e90c0c;
  color: #FFF;
  padding: 7px 15px;
  border-radius: 5px;
  cursor: pointer;
}
</style>